import {IRequestCommand} from 'app/services/authentication/connection/iRequestCommand';
import {IContractorEmployeeRequestDto, ErrorDetails} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import {CommandRequestType} from 'app/services/authentication/connection/commandRequestType';
import {ICommandParameters} from 'app/services/authentication/connection/iCommandParameters';
import {ICommandResponse} from 'app/services/authentication/connection/iCommandResponse';

export class UpdateContractorEmployeeCommand extends IRequestCommand<IUpdateContractorEmployeeResponse, ErrorDetails, IUpdateContractorEmployeeCommandRequest> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;

  public setIds(contractor: number, id: number) {
    this.urlSections.push('contractorEmployees');
    this.urlSections.push(`${contractor}`);
    this.urlSections.push('update');
    this.urlSections.push(`${id}`);
    this.composeUrl();
  }
  public setCommandBody(body: IUpdateContractorEmployeeCommandRequest): void {
    this._commandBody = body;
  }
}

export interface IUpdateContractorEmployeeCommandRequest extends IContractorEmployeeRequestDto,  ICommandParameters {

}

export interface IUpdateContractorEmployeeResponse extends ICommandResponse {
  id: number;
}
